import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { MOCK_FAQ } from '../../utils/mockData';
export function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8" data-id="element-1164">
      <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-1165">
        Frequently Asked Questions
      </h3>

      <div className="space-y-4" data-id="element-1166">
        {MOCK_FAQ.map(faq => <div key={faq.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1167">
            <button onClick={() => setOpenId(openId === faq.id ? null : faq.id)} className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-1168">
              <span className="font-medium text-gray-900" data-id="element-1169">{faq.question}</span>
              {openId === faq.id ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-1170" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-1171" />}
            </button>

            <AnimatePresence data-id="element-1172">
              {openId === faq.id && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="overflow-hidden" data-id="element-1173">
                  <div className="p-4 bg-white text-gray-600 text-sm leading-relaxed border-t border-gray-200" data-id="element-1174">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </div>;
}